module.exports = __webpack_public_path__ + "img/07.20f8016f.gif";